import { render, staticRenderFns } from "./ShortAnswerFeedback.vue?vue&type=template&id=4c4730de&scoped=true&"
import script from "./ShortAnswerFeedback.vue?vue&type=script&lang=js&"
export * from "./ShortAnswerFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ShortAnswerFeedback.vue?vue&type=style&index=0&id=4c4730de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4730de",
  null
  
)

export default component.exports